import React, { useState } from "react";
import "@assets/css/bankCodes.css";

const AlphabetFilter = ({ onSelectLetter }) => {
  const [activeLetter, setActiveLetter] = useState("All");

  const letters = ["All", ...Array.from({ length: 26 }, (_, i) => String.fromCharCode(65 + i))];

  const handleClick = (letter) => {
    setActiveLetter(letter);
    onSelectLetter(letter);
  };

  return (
    <div className="alphabet-filter">
      { letters.map((letter) => (
        <button
          key={ letter }
          className={ `alphabet-btn ${ activeLetter === letter ? "active" : "" }` }
          onClick={ () => handleClick(letter) }
        >
          { letter }
        </button>
      )) }
    </div>
  );
};

export default AlphabetFilter;
